import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-help-center',
  templateUrl: './new-help-center.component.html',
  styleUrls: ['./new-help-center.component.scss']
})
export class NewHelpCenterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
